import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
@Injectable()
export class SeoService {

  siteName: string = 'sportstv';

  constructor(
    private meta: Meta,
    private titleService: Title
  ) { }

  generateTags(config) {
    
    // default values
    config = {
      title: 'sportstv',
      description: 'sportstv Platform, sporun her branşını kapsayan yayıncılık anlayışıyla hareket eden bir premium içerik yaratıcısı; geliştiricisi; sağlayıcısı olmakla birlikte kapsamlı bir OTT platformudur. ',
      image: 'https://sportstv.com.tr/assets/images/template/platform-logo.png',
      slug: '',
      url: 'https://www.sportstv.com.tr',
      ...config
    }

    if (config.url != 'https://www.sportstv.com.tr')
    config.url = 'https://www.sportstv.com.tr' + config.url;
    
    //google
    this.titleService.setTitle(config.title + ' | ' + this.siteName);
    this.meta.updateTag({ name: 'description', content: config.description });

    //twitter
    this.meta.updateTag({ name: 'twitter:card', content: 'summary' });
    this.meta.updateTag({ name: 'twitter:site', content: '@content' });
    this.meta.updateTag({ name: 'twitter:title', content: config.title });
    this.meta.updateTag({ name: 'twitter:description', content: config.description });
    this.meta.updateTag({ name: 'twitter:image', content: config.image });

    //facebook ve diğer sosyal medyalar
    this.meta.updateTag({ property: 'og:type', content: 'article' });
    this.meta.updateTag({ property: 'og:site_name', content: 'content' });
    this.meta.updateTag({ property: 'og:title', content: config.title });
    this.meta.updateTag({ property: 'og:description', content: config.description });
    this.meta.updateTag({ property: 'og:image', content: config.image });
    this.meta.updateTag({ property: 'og:url', content: config.url });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/seo/seo-service.service.ts